import { DefaultService } from '@/services/DefaultService';

/**
 * @deprecated Essa classe foi depreciada e nao devera ser usada.
 */
export default class RelatorioTempoRealService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(rtr) {
        return this._http.post(`${this._env}/agro/realtimereport`, rtr, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    finalize(id) {
        return this._http.get(`${this._env}/agro/realtimereport/${id}/finalize`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    generateRtrToAtendimento(idatendimento) {
        return this._http.get(`${this._env}/agro/agroservice/${idatendimento}/generate-agro-visita`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    uploadAttachment(idrtr, form) {
        return this._http.post(`${this._env}/agro/realtimereport/${idrtr}/attachment`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    listAttachments(id, column = 'datahora', order = 'desc', page = 0, limit = 20) {
        return this._http.get(`${this._env}/agro/realtimereport/${id}/attachments.json?page=${page}&limit=${limit}&column=${column}&order=${order}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

}